import { FC } from "react";
import {
	StreamingLadder,
} from "@video";

const Page:FC = () => {
	return (
		<div>
			<StreamingLadder/>
		</div>
	);
};

export default Page;